import { Search } from "@mui/icons-material"
import { Button, Typography, styled } from "@mui/material"
import { Box } from "@mui/system"
import { memo, } from "react"
import { useSelector } from "react-redux"
import DataTable from "../../components/tables/DataTable"
import ModuleContainer from "../../components/layouts/common/ModuleContainer"
import AsynSearchBar from "../../components/inputs/AsynSearchBar"

const FilterTitleBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    [theme.breakpoints.down('md')]: {
        flexDirection: "column"
    }

}))
const FiltersBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",

    flexWrap: "wrap",
    [theme.breakpoints.down('md')]: {
        flexDirection: "column"
    }
}))


const ListUi = ({ title, filters, setFilters, list, roles, loading, onCreateBtnClick, columns }) => {

    const user = useSelector(state => state.user)

    return (
        <>
            <ModuleContainer
                HeaderComponent={memo(() =>
                    <>
                        <Box flexDirection={"row"} width={"100%"} display={"flex"} justifyContent={"space-between"}>
                            <Box ml={6} display={"flex"}>
                                <Typography sx={{ fontSize: "24px" }}>Audio Track List</Typography>
                            </Box>
                            <Box sx={{ display: "flex", minWidth: "50%", }}>
                                <FilterTitleBox>
                                    <Box sx={{ display: "flex", flex: 1 }} mr={1}>
                                        <AsynSearchBar
                                            fullWidth
                                            title="Search  User  "
                                            size="small"
                                            InputProps={{
                                                startAdornment: <Search sx={{ mr: 2 }} />
                                            }}
                                            placeholder={"Search Name "}
                                            defaultValue={filters.search}
                                            onChange={(changedVal) => {

                                                setFilters({ ...filters, search: changedVal })
                                            }}
                                        />
                                    </Box>

                                    <Button variant="contained" onClick={onCreateBtnClick} >Add Audio Track</Button>
                                </FilterTitleBox>
                            </Box>
                        </Box>

                    </>
                )}
            >
                <Box sx={{ display: "flex", flex: 1, overflow: "hidden", flexDirection: "column", marginLeft: "24px", marginRight: "24px" }}>
                    <DataTable columns={columns} rows={list.result ? list.result : []} count={list.total ?? 0} filters={filters} setFilters={setFilters} loading={loading} />
                </Box>
            </ModuleContainer>
        </>
    )
}
export default ListUi